module.exports = __webpack_public_path__ + "img/plusline.6529f56b.svg";